import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import Helpers, { isActiveSlide, isActiveSidebar, advBookSeries, isSelected, number_format } from "../../../../config/Helpers";
import axios from "axios";
import { parse } from "querystring";

const postUrlDimensions  = API_URL + "dimensions";


class SidebarReview extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            series : {
                serie_30 : "",
                serie_60 : "",
                serie_90 : "",
                serie_120 : "",
                serie_120_more : ""
            },
            period_menu_show : "hide-panel",
        }
    }
    handleClickMenu() {
        this.state.period_menu_show === "hide-panel" ? this.setState({ period_menu_show : "" }) : this.setState({ period_menu_show : "hide-panel" });
    }
    handleClickMenuItem(key, value){
        const current_period  =  { 
            key : key, value : value 
        }
        this.props.setPeriodSidebarReview(current_period)
    }

    componentWillReceiveProps(props){
        let char_keys = Object.keys(props.response_request);
        let $self = this;
        let series
        if (char_keys.length > 0){
            series  = props.response_request["result"]["data_average"];
            Object.keys($self.state.series).map(function(key_serie){
                const serie_item = series[key_serie]["prom"];
                $self.state.series[key_serie] = Object.keys(serie_item).map(function(key_value){
                    let title;
                    let current_value   = serie_item[key_value]["value"];
                    let last_value      = serie_item[key_value]["lastyear_value"];
                    let comp            = serie_item[key_value]["comp"];

                    if(key_value === "adv_book"){
                        
                        title           = "ADV. BOOK PROM";
                        current_value   = number_format(current_value) + " DAYS";
                        last_value      = number_format(last_value) + " DAYS";

                    }else if(key_value === "tariff_adr"){
                        title           = "REVENUE PER PAX";
                        current_value   = "$ " + number_format(current_value,2);
                        last_value      = "$ " + number_format(last_value,2);

                    }else if(key_value === "tariff"){
                        title           = "REVENUE TOTAL";
                        current_value   = "$ " + number_format(current_value);
                        last_value      = "$ " + number_format(last_value);

                    }else if(key_value === "room_nights"){
                        title = "PAX";
                        current_value   = number_format(current_value);
                        last_value      = number_format(last_value);
                    }else{
                        title = "RESERVATIONS";
                        current_value   = number_format(current_value);
                        last_value      = number_format(last_value);
                    }
                    let is_better = parseFloat(comp) !== 0 ? (parseFloat(comp) < 0 ? "worst" : "best") : "hide"
                    return (
                        <div className="sidebar-wdg">
                            <span className="title">{ title }</span>
                            <span className="highlight-title">{ current_value }</span>
                            <div className="footer">
                                <div className="block-1">
                                    <span className="last-year">LAST YEAR</span>
                                    <span className="highlight-last-year">{ last_value }</span>
                                </div>
                                <div className="block-2">
                                    <span className={"rate-type " + is_better}></span>
                                    <span className="highlight-rate">
                                        { comp }%
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                })
            });
        }
    }
    activeSidebar(){
        this.props.setStateSidebarReview()
        if(this.props.sidebar_review.status === ""){
            this.setState({
                period_menu_show : "hide-panel"
            })
        }
    }

    render(){

        const items_series = advBookSeries.map((item, index) =>
            <li onClick={this.handleClickMenuItem.bind(this, item.key, item.value)}>
                {item.key}
            </li>
        );
        return (
            <div className={"sidebar-review " + this.props.sidebar_review.status + " " + this.props.sidebar_review.show}>
                <div className="head-sidebar">
                    <span onClick={this.activeSidebar.bind(this)} className="arrow-press">
                        <span className="arrow"></span>
                    </span>
                    <div className={"select-style type-two " + this.state.period_menu_show} onClick={this.handleClickMenu.bind(this)}>
                        <span className="input-filters select blue custom-period">
                            <span title="Units">{this.props.sidebar_review.current_period.key}</span>
                            <ul>
                                {items_series}
                            </ul>
                        </span>
                    </div>
                </div>
                <div className={isActiveSidebar(this.props.sidebar_review.current_period.value, "serie_30")}>
                    {this.state.series.serie_30}
                </div>
                <div className={isActiveSidebar(this.props.sidebar_review.current_period.value, "serie_60")}>
                    {this.state.series.serie_60}
                </div>
                <div className={isActiveSidebar(this.props.sidebar_review.current_period.value, "serie_90")}>
                    {this.state.series.serie_90}
                </div>
                <div className={isActiveSidebar(this.props.sidebar_review.current_period.value, "serie_120")}>
                    {this.state.series.serie_120}
                </div>
                <div className={isActiveSidebar(this.props.sidebar_review.current_period.value, "serie_120_more")}>
                    {this.state.series.serie_120_more}
                </div>
            </div>
        )
    }
}

export default SidebarReview


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/widgets/SidebarReview.js